import React from "react";
import logo from "../logo.svg";
import { Link } from "react-router-dom";

const CollapseHeaders = () => {
  return (
    <nav class="navbar navbar-expand-lg navbar-dark sticky-top">
      <div class="container">
        <div className="navbar-logo">
          <Link to={"/"} style={{ textDecoration: "none" }}>
            <a href="#" aria-label="icon">
              <img src={logo} alt="logo" />
            </a>
          </Link>
        </div>
        <div id="navbarNav">
          <ul class="navbar-nav ms-auto">
            <li class="nav-item">
              <Link to={"/"} style={{ textDecoration: "none" }}>
                <a class="nav-link text-light" aria-label="icon">
                  Home
                </a>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
export default CollapseHeaders;
